import React from 'react';
import { Link } from 'react-router-dom';
import i18next from 'i18next';

import './ReportBug.scss';

export const ReportBug = () => {
  return (
    <Link className="no-print report-bug" to="/help">
      {i18next.t('report-bug.label')}
    </Link>
  );
};

export default ReportBug;
